export const Banner = () => (
  <section className="relative border-y border-white/10" data-testid="banner-section">
    <img
      src="/images/banner.png"
      alt="Ariane Kamba — Elite Therapeutics. Wellness in Motion. Corporate wellness, touring and production, events and VIP, Euphoria."
      loading="lazy"
      className="w-full h-auto"
    />
  </section>
);
